import React from 'react';
import { Button, Popconfirm } from 'antd';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import { FM221 } from '../../../services/m209Api';

interface Tab2Props {
  details: Partial<FM221>[];
  isEditing: boolean;
  onAdd: () => void;
  onDelete: (idx: number) => void;
  onDetailChange: (idx: number, key: keyof FM221, value: FM221[keyof FM221]) => void;
  totalCount: number;
}

const Tab2Details: React.FC<Tab2Props> = ({
  details, isEditing, onAdd, onDelete, onDetailChange, totalCount,
}) => {
  return (
    <div className="m209-tab2">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
        <span style={{ fontWeight: 600, fontSize: 14 }}>修改明細 ({details.length} 筆)</span>
        {isEditing && (
          <Button type="primary" size="small" icon={<PlusOutlined />} onClick={onAdd}>
            新增明細
          </Button>
        )}
      </div>
      <div style={{ overflowX: 'auto' }}>
        <table className="detail-table">
          <thead>
            <tr>
              <th style={{ width: 45 }}>項數</th>
              <th style={{ width: 165 }}>產品代號</th>
              <th style={{ width: 189 }}>批號</th>
              <th style={{ width: 57 }}>色號</th>
              <th style={{ width: 88 }}>原架號</th>
              <th style={{ width: 96 }}>新架號</th>
              {isEditing && <th style={{ width: 50 }}>操作</th>}
            </tr>
          </thead>
          <tbody>
            {details.length === 0 && (
              <tr>
                <td colSpan={isEditing ? 7 : 6} style={{ textAlign: 'center', color: '#999', padding: 24 }}>
                  尚無明細資料
                </td>
              </tr>
            )}
            {details.map((d, idx) => (
              <tr key={idx}>
                <td style={{ textAlign: 'center' }}>{idx + 1}</td>
                <td>
                  <input
                    type="text"
                    maxLength={12}
                    disabled={!isEditing}
                    value={d.fm221_12 || ''}
                    onChange={e => onDetailChange(idx, 'fm221_12', e.target.value)}
                    style={{ width: '100%' }}
                  />
                </td>
                <td>
                  <input
                    type="text"
                    maxLength={12}
                    disabled={!isEditing}
                    value={d.fm221_11 || ''}
                    onChange={e => onDetailChange(idx, 'fm221_11', e.target.value)}
                    style={{ width: '100%' }}
                  />
                </td>
                <td>
                  <input
                    type="text"
                    readOnly
                    value={d.fm221_14 || ''}
                    style={{ width: '100%' }}
                  />
                </td>
                <td>
                  <input
                    type="text"
                    readOnly
                    value={d.fm221_21 || ''}
                    style={{ width: '100%' }}
                  />
                </td>
                <td>
                  <input
                    type="text"
                    maxLength={5}
                    disabled={!isEditing}
                    value={d.fm221_22 || ''}
                    onChange={e => onDetailChange(idx, 'fm221_22', e.target.value)}
                    style={{ width: '100%' }}
                  />
                </td>
                {isEditing && (
                  <td style={{ textAlign: 'center' }}>
                    <Popconfirm title="確定刪除此明細?" onConfirm={() => onDelete(idx)}>
                      <Button type="link" danger size="small" icon={<DeleteOutlined />} />
                    </Popconfirm>
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Context strip — below grid, matching FoxPro layout */}
      <div className="context-strip">
        <div className="context-left">
          <span className="context-label">色號 :</span>
          <span className="context-value">{/* Color card info placeholder */}</span>
        </div>
        <div className="context-right">
          <span className="context-label">總項數</span>
          <span className="context-count">{totalCount}</span>
        </div>
      </div>
    </div>
  );
};

export default Tab2Details;
